"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const types_1 = require("../../types");
const locales_1 = __importDefault(require("../../utils/locales"));
const SunshineTag_1 = __importDefault(require("../_core/SunshineTag"));
const locales_2 = __importDefault(require("./locales"));
const isInvoice = (type, item) => type === types_1.InvoiceType.Invoice;
const iconNames = new Map([
    [types_1.InvoiceStatus.Canceled, 'cross'],
    [types_1.QuoteStatus.Archived, 'cross'],
    [types_1.InvoiceStatus.Overdue, 'clock-late'],
    [types_1.InvoiceStatus.Sent, 'send'],
    [types_1.QuoteStatus.Sent, 'send'],
    [types_1.InvoiceStatus.Paid, 'tick'],
    [types_1.InvoiceStatus.MarkedAsPaid, 'tick'],
    [types_1.QuoteStatus.Accepted, 'tick'],
    [types_1.InvoiceStatus.Pending, 'save'],
    [types_1.QuoteStatus.Pending, 'save'],
]);
const colors = new Map([
    [types_1.InvoiceStatus.Canceled, 'yellow'],
    [types_1.InvoiceStatus.Overdue, 'red'],
    [types_1.QuoteStatus.Archived, 'red'],
    [types_1.InvoiceStatus.Sent, 'blue'],
    [types_1.QuoteStatus.Sent, 'blue'],
    [types_1.InvoiceStatus.Paid, 'green'],
    [types_1.InvoiceStatus.MarkedAsPaid, 'green'],
    [types_1.QuoteStatus.Accepted, 'green'],
    [types_1.InvoiceStatus.Pending, 'grey'],
    [types_1.QuoteStatus.Pending, 'grey'],
]);
/**
 * @deprecated StatusBadge will soon be removed. Use your platform's own "badge" component instead.
 */
const StatusBadge = ({ lang = locales_1.default, status, type, ...props }) => {
    locales_2.default.setLanguage(lang);
    const label = isInvoice(type, status)
        ? locales_2.default.status[types_1.InvoiceType.Invoice][status]
        : locales_2.default.status[types_1.InvoiceType.Quote][status];
    const iconName = iconNames.get(status);
    const color = colors.get(status);
    return (react_1.default.createElement(SunshineTag_1.default, { colorScheme: color, icon: iconName, ...props }, label));
};
exports.default = StatusBadge;
